module.exports = __webpack_public_path__ + "static/media/hdc-63-wifi.509ea7f6.png";